import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormUtils } from 'src/app/shared/utils/form-utils';
import { Call } from '../../model/call';
import { Message } from '../../model/message';
import {
  CallLogIconView,
  getCallLogIcon,
  getMessageLogIcon,
  isAnsweredCall,
  MessageLogIconView,
} from './call-log-icon.util';

@Component({
  selector: 'app-list-component',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent {
  @Input()
  call?: Call;

  @Input()
  message?: Message;

  @Input()
  contactName?: string;

  @Input()
  type?: string;

  get callIcon(): CallLogIconView | null {
    return this.call ? getCallLogIcon(this.call) : null;
  }

  get messageIcon(): MessageLogIconView | null {
    return this.message ? getMessageLogIcon(this.message) : null;
  }

  public showCallDuration(): boolean {
    return !!this.call && isAnsweredCall(this.call);
  }

  public isContactNameError(): boolean {
    if (this.type === 'call' && this.callIcon) {
      return this.callIcon.kind === 'error' || this.callIcon.kind === 'missed';
    }
    if (this.type === 'message' && this.messageIcon) {
      return this.messageIcon.kind === 'error';
    }
    return false;
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) {
      return '';
    }
    return FormUtils.formatPhoneNumber(phone);
  }
}
